import * as Immutable from "immutable"

import { AbstractOperationMessage } from "./abstractOperationMessage"

export class BomOperationMessage extends AbstractOperationMessage {

  protected readonly BOM_PANEL_ID = "bomPanelId";

  get bomPanelId(): number { return this.getInternalValue<number>(this.BOM_PANEL_ID); }
  setBomPanelId(bomPanelId: number): this { return this.setInternalValue(this.BOM_PANEL_ID, bomPanelId); }
  
}